import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import {
  createTheme,
  ThemeProvider,
  Theme,
  StyledEngineProvider
} from '@mui/material/styles';
import { SnackbarProvider } from 'notistack';
import configureStore from './app/store';
import App from './app/App';
import * as serviceWorker from './serviceWorker';
import { AuthProvider } from './app/context/auth-context';
import { QueryClient, QueryClientProvider } from 'react-query';

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

//import { ReactQueryDevtools } from 'react-query/devtools';

const store = configureStore();

// const theme = createTheme(
//   adaptV4Theme({
//     palette: {
//       primary: {
//         main: '#1C9996'
//       },
//       secondary: {
//         main: '#1F3444'
//       }
//     }
//   })
// );

// Convert to MUI v5
const theme = createTheme({
  palette: {
    primary: {
      main: '#1C9996'
    },
    secondary: {
      main: '#1F3444'
    }
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
      //staleTime:60000,
      //refetchOnMount:false
    }
  }
});

// Fix to prevent API Not Configured error when build
// API.configure({
//   endpoints: [
//     {
//       name: 'noti',
//       endpoint: config.apiGateway.URL,
//       region: config.apiGateway.REGION
//     }
//   ]
// });

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <AuthProvider>
            <Router>
              <SnackbarProvider maxSnack={3}>
                <App />
              </SnackbarProvider>
            </Router>
          </AuthProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </Provider>
  </QueryClientProvider>,

  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
